import { useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import { withAppHOC } from "../../hoc";
import {
  StyledContentContainer,
  StyledMainAreaContainer,
} from "../../components/styled";
import PageHeader from "../../components/PageHeader/PageHeader";
import {
  Form,
  Fieldset,
  Label,
  TextInput,
  MessageBox,
  Button,
  Dropdown,
} from "../../components/FormElements";
import API from "../../api";
import { RESPONSE_STATUSES } from "../../constants";
import { getBase64, getReturnUrl } from "../../utils";
import { isEmpty } from "lodash";

const StyledInput = styled.textarea`
  background-color: #f9fafb;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  padding: 15px;
  margin: 0px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  width: calc(100% - 32px);
  flex: 2;
  background-color: #f9fafb;resize: none;
  outline: 0px;min-height: 300px
`;

const SupportCreate = () => {
  const inputRef = useRef(null);
  const [state, setState] = useState({
    isLoading: false,
    responseStatus: "",
    responseMessage: "",
    typesId: "",
    subTypesId: "",
    description: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: "",
      responseMessage: "",
    }));
    try {
      const response = await API.post("/help/support", {
        typesId: state.typesId,
        subTypesId: state.subTypesId,
        description: state.description,
      });
      const { status, message } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          typesId: "",
          subTypesId: "",
          description: "",
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: "",
            responseMessage: "",
          }));
          window.location.href = getReturnUrl("create");
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const readMeta = async () => {
    try {
      const response = await API.get(`/meta`);
      return response?.data?.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const { data: meta } = useQuery({
    queryKey: ["meta"],
    queryFn: readMeta,
  });

  const typeOptions = [
    {
      name: "-- SELECT TYPE --",
      value: "",
    },
  ];
  !isEmpty(meta?.ticketTypes) &&
    meta?.ticketTypes?.forEach(({ type, id }) =>
      typeOptions?.push({ name: type, value: id })
    );
  const subtypeOptions = [
    {
      name: "-- SELECT SUB TYPE --",
      value: "",
    },
  ];
  !isEmpty(meta?.ticketSubTypes) &&
    meta?.ticketSubTypes?.filter(item => state.typesId === '' || state.typesId?.toString() === item.typesId?.toString())?.forEach(({ subtype, id }) =>
      subtypeOptions?.push({ name: subtype, value: id })
    );

  const renderPageHeading = () => (
    <PageHeader title="Create Support Ticket" showBackButton={true} />
  );

  return (
    <>
      {renderPageHeading()}
      <StyledContentContainer>
        <StyledMainAreaContainer>
          <Form
            action="#"
            method="POST"
            onSubmit={onSubmit}
            style={{ maxWidth: "500px" }}
          >
            <Fieldset>
              <Label required>Type</Label>
              <Dropdown
                value={state.typesId}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    typesId: value,
                  }))
                }
                placeholder="Type"
                disabled={state.isLoading}
                options={typeOptions}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Sub Type</Label>
              <Dropdown
                value={state.subTypesId}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    subTypesId: value,
                  }))
                }
                placeholder="Sub Type"
                disabled={state.isLoading || !state.typesId}
                options={subtypeOptions}
              />
            </Fieldset>
            <Fieldset>
              <Label required>Description</Label>
              <StyledInput
                value={state.description}
                isNumeric={true}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    description: e.target.value,
                  }))
                }
                placeholder="Description"
                disabled={state.isLoading || !state.typesId || !state.subTypesId}
              />
            </Fieldset>
            {state.responseStatus && state.responseMessage && (
              <Fieldset>
                <MessageBox
                  status={state.responseStatus}
                  message={state.responseMessage}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Button disabled={state.isLoading}>Create</Button>
            </Fieldset>
          </Form>
        </StyledMainAreaContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(SupportCreate);
